import { render, staticRenderFns } from "./VideoPopupModV3.vue?vue&type=template&id=012255c7&scoped=true"
import script from "./VideoPopupModV3.vue?vue&type=script&lang=js"
export * from "./VideoPopupModV3.vue?vue&type=script&lang=js"
import style0 from "./VideoPopupModV3.vue?vue&type=style&index=0&id=012255c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012255c7",
  null
  
)

export default component.exports